/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LocationsSearchByAreaQueryVariables = Types.Exact<{
  topLeft: Types.GeoCoordinates;
  bottomRight: Types.GeoCoordinates;
  showHidden?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type LocationsSearchByAreaQuery = {
  readonly __typename?: 'Query';
  readonly searchLocationsByBoundingBox: ReadonlyArray<{
    readonly __typename?: 'LocationSearchResult';
    readonly location: {
      readonly __typename?: 'StoreLocation';
      readonly id: string;
      readonly name: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly slug: string;
      readonly address: string;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly isOutpost: boolean | null;
      readonly phone: string | null;
      readonly storeHours: string | null;
      readonly flexMessage: string | null;
      readonly enabled: boolean;
      readonly acceptingOrders: boolean;
      readonly notAcceptingOrdersReason: string | null;
      readonly imageUrl: string;
      readonly hidden: boolean;
      readonly showWarningDialog: boolean;
      readonly warningDialogDescription: string | null;
      readonly warningDialogTimeout: number | null;
      readonly warningDialogTitle: string | null;
    };
  } | null> | null;
};

export const locationsSearchByAreaQueryMock: ExecutionResult<LocationsSearchByAreaQuery> =
  {
    data: {
      searchLocationsByBoundingBox: [
        {
          location: {
            id: '509e6ea9-fee4-42a9-9625-87ce71904308',
            name: 'Hello World',
            latitude: 64.46,
            longitude: 37.39,
            slug: 'Hello World',
            address: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: false,
            phone: 'Hello World',
            storeHours: 'Hello World',
            flexMessage: 'Hello World',
            enabled: true,
            acceptingOrders: false,
            notAcceptingOrdersReason: 'Hello World',
            imageUrl: 'Hello World',
            hidden: false,
            showWarningDialog: false,
            warningDialogDescription: 'Hello World',
            warningDialogTimeout: -61.62,
            warningDialogTitle: 'Hello World',
          },
        },
        {
          location: {
            id: 'ba7eda96-e8a1-485e-bda0-0a9a47534319',
            name: 'Hello World',
            latitude: 70.04,
            longitude: -89.93,
            slug: 'Hello World',
            address: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: true,
            phone: 'Hello World',
            storeHours: 'Hello World',
            flexMessage: 'Hello World',
            enabled: false,
            acceptingOrders: false,
            notAcceptingOrdersReason: 'Hello World',
            imageUrl: 'Hello World',
            hidden: false,
            showWarningDialog: true,
            warningDialogDescription: 'Hello World',
            warningDialogTimeout: -28.75,
            warningDialogTitle: 'Hello World',
          },
        },
        {
          location: {
            id: '9aa250f9-c401-46b1-bd63-4cb273b7f9f1',
            name: 'Hello World',
            latitude: 6.88,
            longitude: 69.23,
            slug: 'Hello World',
            address: 'Hello World',
            city: 'Hello World',
            state: 'Hello World',
            zipCode: 'Hello World',
            isOutpost: false,
            phone: 'Hello World',
            storeHours: 'Hello World',
            flexMessage: 'Hello World',
            enabled: false,
            acceptingOrders: false,
            notAcceptingOrdersReason: 'Hello World',
            imageUrl: 'Hello World',
            hidden: true,
            showWarningDialog: false,
            warningDialogDescription: 'Hello World',
            warningDialogTimeout: 45.31,
            warningDialogTitle: 'Hello World',
          },
        },
      ],
    },
  };

export const LocationsSearchByAreaDocument = gql`
  query LocationsSearchByArea(
    $topLeft: GeoCoordinates!
    $bottomRight: GeoCoordinates!
    $showHidden: Boolean
  ) {
    searchLocationsByBoundingBox(
      topLeft: $topLeft
      bottomRight: $bottomRight
      showHidden: $showHidden
    ) {
      location {
        id
        name
        latitude
        longitude
        slug
        address
        city
        state
        zipCode
        isOutpost
        phone
        storeHours
        flexMessage
        enabled
        acceptingOrders
        notAcceptingOrdersReason
        imageUrl
        hidden
        showWarningDialog
        warningDialogDescription
        warningDialogTimeout
        warningDialogTitle
      }
    }
  }
`;

export function useLocationsSearchByAreaQuery(
  options: Omit<
    Urql.UseQueryArgs<LocationsSearchByAreaQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LocationsSearchByAreaQuery,
    LocationsSearchByAreaQueryVariables
  >({ query: LocationsSearchByAreaDocument, ...options });
}
